module.exports = __webpack_public_path__ + "static/media/as6tj538.a2c663ab.png";